import { AbstractControl } from "@angular/forms";

const MONTH_START = 15; // For Monthly Progress
const ROLE = {
  MANUFACTURER: "manufacturer",
  ULB: "ulb",
  VENDOR: "vendor",
  ADMIN: "admin",
  CITIZEN: "citizen",
};

const RECAPTCHA_SITE_KEY = "6Ld5oBcsAAAAAPhPaXuOc7JxxHOSRSZ6OjWkBAAq";

const PATTERN = {
  MOBILE: "[6-9]{1}[0-9]{9}",
  DECIMAL: "^(([1-9]{1}[0-9]*)|([0-9][.][0-9]+))+(?:([.][0-9]{1}[0-9]*))?$",
  PERCENT: "^(100|[1-9]{1}(?:[0-9]{1})?)%?$",
  EMAIL: "^[a-zA-Z0-9_.-]+@[a-zA-Z0-9]+[a-zA-Z0-9.-]+[a-zA-Z0-9]+.[a-z]{1,3}$",
  //AADHAAR: '[1-9]{11}[0-9]{1}',
  AADHAAR: "^[0-9]{4}[ -]?[0-9]{4}[ -]?[0-9]{4}$",
  VOTER: "^([a-zA-Z]){3}([0-9]){7}?$",
  Employee: "^[a-zA-Z0-9_]*$",
  PAN: "[A-Z]{5}[0-9]{4}[A-Z]{1}",
  TAN: "[A-Z]{4}[0-9]{5}[A-Z]{1}",
  GST: "^([0][1-9]|[1-2][0-9]|[3][0-8])([a-zA-Z]{4}[a-zA-Z0-9]{1}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[1-9a-zA-Z]{1}[0-9a-zA-Z]{1})+$",
  PIN: "[1-9]{1}[0-9]{5}",
  CIN: "^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$",
  DIN: "[1-9]{1}[0-9]{7}",
  NONZERO: "^(0*[1-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$",
  NATURALNUMBERS: "^[1-9][0-9]*$",
  LATITUDE:
    "^(\\+|-)?(([0-9]((.)|.[0-9]{1,6})?)|(0*?[0-8][0-9]((.)|.[0-9]{1,7})?)|(0*?90((.)|.0{1,7})?))$",
  LONGITUDE:
    "^(\\+|-)?(([0-9]((.)|.[0-9]{1,6})?)|(0*?[0-9][0-9]((.)|.[0-9]{1,7})?)|(0*?1[0-7][0-9]((.)|.[0-9]{1,7})?)|(0*?180((.)|.0{1,7})?))$",
  WEBSITE:
    "(https?)?:\\/\\/(www.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)",
  LATITUDEPATTERN:
    "^(\\+|-)?(?:90(?:(?:\\.0{1,15})?)|(?:[0-9]|[1-8][0-9])(?:(?:\\.[0-9]{1,15})?))$",
  LONGITUDEPATTERN:
    "^(\\+|-)?(?:180(?:(?:\\.0{1,15})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,15})?))$",
};

const RESTRICT = {
  CHAR: "charOnly",
  NUMBER: "numberOnly",
  ALPHANUM: "alphaNum",
  AMOUNT: "amount",
  DECIMAL: "decimal",
  PWD: "password",
  TEXT: "text",
};

const MONTHS = [
  { monthNumber: 1, month: "JANUARY" },
  { monthNumber: 2, month: "FEBRUARY" },
  { monthNumber: 3, month: "MARCH" },
  { monthNumber: 4, month: "APRIL" },
  { monthNumber: 5, month: "MAY" },
  { monthNumber: 6, month: "JUNE" },
  { monthNumber: 7, month: "JULY" },
  { monthNumber: 8, month: "AUGUST" },
  { monthNumber: 9, month: "SEPTEMBER" },
  { monthNumber: 10, month: "OCTOBER" },
  { monthNumber: 11, month: "NOVEMBER" },
  { monthNumber: 12, month: "DECEMBER" },
];

const TO_DECIMAL = 5;

enum SOURCE {
  SWM = "SWM",
  CND = "CND",
  SANITATION = "SANITATION",
}

const KEYS = {
  MAPS: "AIzaSyBjSLJ886DO_hgNFETwMWvREKHBjBNdX6I",
  AES_KEY: "TOKEN_SECURITY_RIS_AES_KEY_IN_JWT",
};

const APPID = {
  PLANT: "ddc47733-842f-4986-9305-0e7f582de37e",
  MONTHLY_PROGRESS: "24b8a241-dce8-47e2-9834-0dbf260849bd",
};
const MODULEID = {
  GEN_COLL_DIST: "71b6783b-458c-4bc0-986f-a7fa7d3b4c7a",
};

const FILE_SIZE_LIMIT = 10; // in MB

const ACTIONS = {
  PLANT_INPUTS: "028c6ac5-bf54-4b8f-816a-1456e033f3db",
  PLANT_OUTPUTS: "654d9247-b1f8-4977-ac3b-d1a12ab11a27",
  PLANT_INPUTS_UNIT: "400aed5b-4cd2-4d24-b7fa-d90da37c06e1",
  PLANT_OUTPUT_UNIT: "46f6cc21-571c-48f6-8eb5-c5ce8ffc9bd0",
  SWM_COLLECTION: "827a9301-1628-4909-ae22-d12474091568",
  CND_COLLECTION: "25f6c640-8dd0-4045-a87e-2a693c738f7a",
  SANITATION_COLLECTION: "877aa405-eb61-460e-8d45-8695243ce27b",
  WASTE_DISTRIBUTION: "Waste Distribution",
};

const OUTSIDE_CITY = {
  id: 0,
  wardNumber: 0,
  wardName: "Outside City Boundary",
};

export {
  MONTH_START,
  RECAPTCHA_SITE_KEY,
  TO_DECIMAL,
  ROLE,
  PATTERN,
  RESTRICT,
  KEYS,
  FILE_SIZE_LIMIT,
  OUTSIDE_CITY,
  SOURCE,
  MONTHS,
  APPID,
  MODULEID,
  ACTIONS,
};

export function dobValidator(
  control: AbstractControl
): { [key: string]: boolean } | null {
  if (control.value) {
    // Get today's date
    const today = new Date();

    // User's input DOB
    const dob = new Date(control.value);
    const monthDiff = today.getMonth() - dob.getMonth();

    // Calculate age
    let age = today.getFullYear() - dob.getFullYear();

    // Check if the user is at least 18 years old

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() > dob.getDate())) {
      age--;
    }

    if (age < 18) {
      return { underAge: true };
    }
  }
  return null;
}
